/** @format */

import CloseIcon from '@mui/icons-material/Close';
import Alert, { AlertColor } from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { FeedbackDto } from '../models/requests/FeedbackDto';

interface Props {
  setFeedback: React.Dispatch<React.SetStateAction<FeedbackDto>>;
  feedback: FeedbackDto;
}

const InlineAlert = styled(Alert)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 1.5,
  alignItems: 'flex-start',
  padding: theme.spacing(1.25, 1.25, 1.25, 2),
  marginBottom: theme.spacing(2),
  boxShadow:
    theme.palette.mode === 'dark'
      ? '0 6px 24px rgba(0,0,0,0.35)'
      : '0 6px 24px rgba(15, 23, 42, 0.08), 0 1px 4px rgba(15, 23, 42, 0.04)',
  border: '1px solid',
  borderColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255,255,255,0.08)'
      : 'rgba(15, 23, 42, 0.06)',
  '& .MuiAlert-message': {
    padding: theme.spacing(0.25, 0, 0, 0),
    width: '100%',
  },
  '& .MuiAlert-icon': {
    marginRight: theme.spacing(1.5),
    padding: 0,
    fontSize: 22,
  },
}));

export default function CustomAlerts({ setFeedback, feedback }: Props) {
  const severity: AlertColor =
    feedback.severity === 'success' ||
    feedback.severity === 'error' ||
    feedback.severity === 'warning' ||
    feedback.severity === 'info'
      ? feedback.severity
      : 'info';

  return (
    <Box sx={{ width: '100%' }}>
      {feedback.validation?.messages?.map((message, key) => (
        <Collapse in={feedback.open} key={key}>
          <InlineAlert
            severity={severity}
            variant='standard'
            action={
              <IconButton
                aria-label='Dismiss notification'
                color='inherit'
                size='small'
                sx={{ mt: -0.25 }}
                onClick={() => {
                  setFeedback((prev) => ({
                    ...prev,
                    open: false,
                  }));
                }}>
                <CloseIcon fontSize='small' />
              </IconButton>
            }>
            <Typography
              component='span'
              variant='body2'
              sx={{ fontWeight: 500, lineHeight: 1.5 }}>
              {message}
            </Typography>
          </InlineAlert>
        </Collapse>
      ))}
    </Box>
  );
}
